import { render, staticRenderFns } from "./customerProduction.vue?vue&type=template&id=616c5486&scoped=true"
import script from "./customerProduction.vue?vue&type=script&lang=js"
export * from "./customerProduction.vue?vue&type=script&lang=js"
import style0 from "./customerProduction.vue?vue&type=style&index=0&id=616c5486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c5486",
  null
  
)

export default component.exports